import { useQuery } from '@apollo/client';
import { useClearAccount, useTranslationInput } from '@application/api';
import { graphql } from '@gql/gql';
import type { MtLittersGetLittersQuery, MtLittersGetLittersQueryVariables } from '@gql/graphql';
import { SortOrder } from '@gql/graphql';

export const MT_LITTERS_GET_LITTERS = graphql(`
  query MtLittersGetLitters(
    $orderBy: LitterOrderByWithRelationAndSearchRelevanceInput
    $where: LitterWhereInput!
    $translationsWhere: DogBreedTranslationWhereInput!
  ) {
    accountMe {
      id
      dogBreeder {
        id
        litters(where: $where, orderBy: $orderBy) {
          id
          adminValidated

          archived

          price
          priceFrom
          priceTo
          fixedPrice
          birthday
          availabilityDate
          description
          malesLeftCount
          femalesLeftCount

          malesCount
          femalesCount
          microchipped
          microchips
          vaccinated
          vaccinationDate
          pedigree
          pedigreeNumbers
          dewormed

          imgs {
            id
            small
          }

          parents {
            id
            parentType
            name
            testsResults
            titles
            microshipNumber
            pedigreeType
            pedigreeNumber
            img
          }

          dogBreed {
            id
            name
            translations(where: $translationsWhere) {
              id
              name
            }
            imgs {
              id
              small
            }
          }
        }
      }
    }
  }
`);

export const useGetLitters = (archived = false) => {
  const { translationInput } = useTranslationInput();
  const { redirectOnTokenErrorHandler } = useClearAccount();

  const { data, error, loading } = useQuery<
    MtLittersGetLittersQuery,
    MtLittersGetLittersQueryVariables
  >(MT_LITTERS_GET_LITTERS, {
    variables: {
      where: {
        ...(archived
          ? { archived: { equals: true } }
          : { OR: [{ archived: { equals: false } }, { archived: { equals: null } }] }),
      },
      orderBy: { malesLeftCount: { sort: SortOrder.desc } },

      ...translationInput,
    },
    fetchPolicy: 'network-only',
    onError: redirectOnTokenErrorHandler,
    ssr: false,
  });

  return {
    litters: data?.accountMe?.dogBreeder?.litters,
    littersError: error,
    littersLoading: loading,
  };
};
